import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import Paragraph from '../Typography/Paragraph/Paragraph';
import styles from './FilterDropdown.module.scss';
import Heading from '../Typography/Heading/Heading';
import { firstLetterUpperCase } from '../../helpers';
import ColorBox from '../ColorBox/ColorBox';
import RangeSlider from '../RangeSlider/RangeSlider';
import { ReactComponent as ArrowDown } from '../../assets/icons/arrow-down2.svg';
import CancelIcon from '../CancelIcon/CancelIcon';
import useQuery from '../../hooks/useQuery';
import DatePicker from '../DatePicker/DatePicker';
import LocationInput from '../LocationInput/LocationInput';
import AdditionalSelectInput from '../../views/AdditionalSelectInput/AdditiondalSelectInput';
import { ColorFilterOptions } from '../../constants/colorFilterOptions';
const FilterDropdown = ({ title, className, textFilterOptions, colorFilterOptions, range, onChange, date, location }) => {
    const ref = useRef();
    const { t } = useTranslation();
    const [moreElements, setMoreElements] = useState(true);
    const [rangeMoreElements, setRangeMoreElements] = useState(false);
    const query = useQuery();
    const currentFilter = query[title.toLocaleLowerCase()];
    const COLOR_TITLES = useMemo(() => {
        return ColorFilterOptions.map((el) => {
            return { label: el.title, value: el.title };
        });
    }, [ColorFilterOptions]);
    const [lastSelected, setLastSelected] = useState(COLOR_TITLES[0]);
    const [colors, setColors] = useState(ColorFilterOptions[0].colors);
    const onTextClick = (text) => {
        const parsedText = text.split(' ').join('-');
        onChange && onChange({ [title.toLowerCase()]: parsedText === 'All' ? '' : parsedText });
    };
    const onDateChange = (date) => {
        onChange && onChange({ [title.toLowerCase()]: date.toLocaleDateString() });
    };
    const handleLocationChange = (event) => {
        const { value } = event.target;
        onChange && onChange({ [title.toLowerCase()]: value });
    };
    useEffect(() => {
        colorFilterOptions || range || date || location
            ? setMoreElements(false)
            : setMoreElements(true);
    }, [colorFilterOptions, range, date, location]);
    //Selecting collection colors
    const handleColorSelect = useCallback((e) => {
        const { label } = e;
        const colors = ColorFilterOptions.find((el) => el.title === label).colors;
        setLastSelected(e);
        setColors(colors);
    }, []);
    //Getting the Colors of last selected Collection
    const getRecentCollectionColors = useCallback(() => {
        const collection = ColorFilterOptions.find((el) => el.title === lastSelected.label);
        if (collection) {
            return collection.colors;
        }
        return [];
    }, [lastSelected]);
    //Updating colors when collapsed
    const handleArrowDown = () => {
        setColors(getRecentCollectionColors());
    };
    return (_jsxs("div", Object.assign({ className: cn(styles.element, className) }, { children: [_jsxs("div", Object.assign({ onClick: () => {
                    setMoreElements(!moreElements);
                    setRangeMoreElements(!rangeMoreElements);
                }, className: cn(styles.title, 'd-flex justify-content-between w-100 align-items-center') }, { children: [_jsx(Heading, { size: 4, fontWeight: 600, title: firstLetterUpperCase(title) }), _jsx(ArrowDown, { className: moreElements ? styles['isActive'] : '', onClick: handleArrowDown })] }), title), currentFilter && currentFilter !== 'all' && (_jsx(CancelIcon, { className: styles.cancelIcon, onClick: () => {
                    onTextClick('All');
                } })), textFilterOptions &&
                textFilterOptions.map(({ name, value }) => moreElements && (_jsx(Paragraph, { onClick: () => {
                        onTextClick(value);
                    }, className: cn(styles.text, t(currentFilter || '').toLocaleLowerCase() ===
                        name.toLocaleLowerCase() ||
                        t(currentFilter || '').toLocaleLowerCase() ===
                            value.toLocaleLowerCase()
                        ? styles['isActive']
                        : ''), title: firstLetterUpperCase(name) }, name))), colorFilterOptions && rangeMoreElements && (_jsxs(_Fragment, { children: [_jsx(AdditionalSelectInput, { onChange: handleColorSelect, options: COLOR_TITLES, selectedOption: lastSelected.label }), colors.length > 0 && (_jsx(ColorBox, { title: title, onChange: onChange, colors: colors }))] })), range && query[title.toLocaleLowerCase() + 'Min'] && (_jsx(CancelIcon, { className: styles.cancelIcon, onClick: () => ref.current.handleParentReset() })), range && (_jsx(_Fragment, { children: _jsx(RangeSlider, { ref: ref, show: rangeMoreElements, title: title, onChange: onChange, min: range.min, max: range.max }) })), date && rangeMoreElements && (_jsx(DatePicker, { placeholder: 'Pick a date', onChange: onDateChange })), location && rangeMoreElements && _jsx(LocationInput, { onChange: handleLocationChange })] })));
};
export default FilterDropdown;
